import Quill from "quill";

/**
 * Default Quill size uses CSS classes (ql-size-small, etc.). Email clients do not
 * load Quill styles, so sizes disappear. Register the style attributor so HTML
 * carries inline font-size (e.g. style="font-size: 18px").
 */
const SizeStyle = Quill.import("attributors/style/size");
Quill.register(SizeStyle, true);
